var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ios_share_black_24dp",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2266",
    "data-name": "Rectangle 2266",
    width: 33,
    height: 33,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(5.457 1.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M20.371,6.457,18.434,8.394,16.265,6.225V21.464h-2.7V6.225L11.394,8.394,9.457,6.457,14.914,1Zm5.457,6.821V28.286A2.737,2.737,0,0,1,23.1,31.014H6.729A2.728,2.728,0,0,1,4,28.286V13.279A2.719,2.719,0,0,1,6.729,10.55h4.093v2.729H6.729V28.286H23.1V13.279H19.007V10.55H23.1A2.728,2.728,0,0,1,25.829,13.279Z",
    transform: "translate(-4 -1)",
    fill: "#f6f7fa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGrey);
export default __webpack_public_path__ + "static/media/ShareGrey.c59580d661f0bdc1bc99536037d9ba71.svg";
export { ForwardRef as ReactComponent };